webpackJsonp([60,61],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_index__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router_index__ = __webpack_require__(38);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return initAppData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return getonlinecardRule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return onlinecardInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return subLackBook; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getUserLackBookList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return borrowBook; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return resetCardPassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return getIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return getArticle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getSearchHot; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getSearchResult; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return getSuitBookList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return getIsbnResult; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return getCatagrayList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return getCatagrayBookList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return getSubjectBookList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return getBook; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return getUserAddress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return getBookOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return getpointrule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return getPrize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return getTaskCenter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return loginIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return loginOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return sendPhoneCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return validatePhoneCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return signUpSetPassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return getexchange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getWechatSet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return getCashPrizeInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return getCashPrizeAddress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return getPointflow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return sureExchange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return signToday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return getPointIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return uploadProfile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return editUserInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return changePhone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return getMyBorrow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return cancelBorrowOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return orgList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return bindingCard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return messageList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return isBinding; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return editAddress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return getMyBookcase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return deleteAddress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return deleteBookCase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return getExpressTrace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return orderDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return unbunding; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return addAddress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return setDefAddress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return returnBorrow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return renewBorrow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return addressInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return resetPassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return changePassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return getmenuItemList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return addBookshelf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return specialBookList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return getOnlinecard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return beginOnlinecard; });
/* unused harmony export UpLoadCardfile */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return wxpay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return payOk; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return getOrderDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return hasEcardOrgList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return sharePoint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return confirmSignup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return tipIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return getEcardFee; });





var locationUrl = location.href.split('#')[0];
locationUrl = locationUrl.split('?')[0];
var baseUrl = locationUrl.replace('/shuduier/', '');
__WEBPACK_IMPORTED_MODULE_2__store_index__["a" /* default */].dispatch('SET_BASEURL', baseUrl);
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.baseURL = __WEBPACK_IMPORTED_MODULE_2__store_index__["a" /* default */].state.baseurl + '/api/';

var initAppData = function initAppData(url) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        url: 'init',
        params: {
            url: url
        }
    });
};

var getWechatSet = function getWechatSet(url) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        url: 'weixin/wxjssdk',
        params: {
            url: url
        }
    });
};

__WEBPACK_IMPORTED_MODULE_1_axios___default.a.interceptors.request.use(function (config) {
    __WEBPACK_IMPORTED_MODULE_2__store_index__["a" /* default */].dispatch('UPDATE_LOADING_STATUS', { isLoading: true });
    return config;
}, function (error) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

__WEBPACK_IMPORTED_MODULE_1_axios___default.a.interceptors.response.use(function (response) {
    __WEBPACK_IMPORTED_MODULE_2__store_index__["a" /* default */].dispatch('UPDATE_LOADING_STATUS', { isLoading: false });
    if (!response.data.status && response.data.errorKey === 'unavailable') {
        __WEBPACK_IMPORTED_MODULE_3__router_index__["a" /* default */].replace({ path: '/systemMaintenance' });
    }
    return response;
}, function (error) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

var getIndex = function getIndex() {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()('');
};

var getArticle = function getArticle(article_id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()('article/' + article_id);
};

var subLackBook = function subLackBook(book_title, book_isbn) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        url: 'user/checkin',
        params: {
            title: book_title,
            isbn: book_isbn
        }
    });
};

var getUserLackBookList = function getUserLackBookList(page, rows) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        url: 'user/checkinList',
        params: {
            page: page,
            rows: rows
        }
    });
};

var getSearchResult = function getSearchResult(search) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        url: 'book/search',
        params: {
            key: search.key,
            sort: search.sort,
            way: search.way,
            page: search.page,
            rows: search.rows
        }
    });
};

var getSearchHot = function getSearchHot() {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()('book/searchHotKey');
};

var getCatagrayList = function getCatagrayList() {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        url: 'category/categoryitemList',
        params: {
            child: 'child'
        }
    });
};

var getSuitBookList = function getSuitBookList(book_id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()('book/booksuitList/' + book_id);
};

var getIsbnResult = function getIsbnResult(isbn) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        url: 'book/findIsbn',
        params: {
            isbn: isbn
        }
    });
};

var getCatagrayBookList = function getCatagrayBookList(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        url: 'book/categoryBookList',
        params: {
            clc_code: params.clc_code,
            page: params.page,
            rows: params.rows
        }
    });
};

var getSubjectBookList = function getSubjectBookList(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        url: 'book/subjectBookList/' + params.subject_id,
        params: {
            page: params.page,
            rows: params.rows
        }
    });
};

var getBook = function getBook(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        url: 'book/' + params.book_id
    });
};

var getUserAddress = function getUserAddress() {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        url: 'user/myAddress'
    });
};

var borrowBook = function borrowBook(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        url: 'borrow/borrowBook',
        params: params
    });
};

var resetCardPassword = function resetCardPassword(passWord) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        url: 'user/resetCardpwd',
        method: 'post',
        params: {
            cardpwd: passWord
        }
    });
};

var getBookOrder = function getBookOrder(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        url: 'borrow/borrowDetail/' + params.book_id,
        params: {
            address_id: params.address_id,
            booksuit_id: params.booksuit_id
        }
    });
};

var getpointrule = function getpointrule() {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()('mall/pointruleList');
};

var getPrize = function getPrize(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()('mall/prize/' + id);
};

var getexchange = function getexchange() {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()('mall/myExchange');
};

var getCashPrizeInfo = function getCashPrizeInfo(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        url: 'mall/prizeOrder/' + id
    });
};

var getCashPrizeAddress = function getCashPrizeAddress(id, address_id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        url: 'mall/prizeOrder/' + id,
        params: {
            address_id: address_id
        }
    });
};

var getMyBookcase = function getMyBookcase(sort, page, rows) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        url: 'user/myBookshelf',
        method: 'get',
        params: {
            sort: sort,
            page: page,
            rows: rows
        }
    });
};

var getExpressTrace = function getExpressTrace(expressorder_id, user_id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        url: 'user/expressTrace/' + expressorder_id
    });
};

var getPointflow = function getPointflow() {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()('mall/pointflow');
};

var getPointIndex = function getPointIndex() {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()('mall');
};

var sureExchange = function sureExchange(id, address_id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        url: 'mall/exchange/' + id,
        method: 'post',
        params: {
            address_id: address_id
        }
    });
};

var orderDetail = function orderDetail(borrowno) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        url: 'borrow/' + borrowno
    });
};

var getTaskCenter = function getTaskCenter(user_id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()('mall/pointTask');
};

var getmenuItemList = function getmenuItemList() {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()('help');
};

var renewBorrow = function renewBorrow(borrow_id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        url: 'borrow/renewBorrow/' + borrow_id
    });
};

var cancelBorrowOrder = function cancelBorrowOrder(borrow_id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        url: 'borrow/cancelBorrowBook',
        method: 'post',
        params: {
            borrow_id: borrow_id
        }
    });
};

var returnBorrow = function returnBorrow(borrow_id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        url: 'borrow/returnBorrow/' + borrow_id
    });
};

var signToday = function signToday() {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        url: 'mall/signin',
        method: 'post'
    });
};

var getMyBorrow = function getMyBorrow(status, page, rows) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        url: 'borrow/borrowList',
        method: 'get',
        params: {
            status: status,
            page: page,
            rows: rows
        }
    });
};

var deleteBookCase = function deleteBookCase(bs_id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        url: 'user/deleteBookshelf/' + bs_id,
        method: 'post'
    });
};

var loginIn = function loginIn(name, password) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        url: 'user/loginIn',
        method: 'post',
        params: {
            name: name,
            password: password
        }
    });
};

var loginOut = function loginOut() {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        url: 'user/loginOut'
    });
};

var sendPhoneCode = function sendPhoneCode(phone, type, isSessionPhone) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        url: 'user/phoneCode',
        method: 'get',
        params: {
            phone: phone,
            type: type,
            isSessionPhone: isSessionPhone
        }
    });
};

var validatePhoneCode = function validatePhoneCode(code) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        url: 'user/validatePhoneCode',
        method: 'get',
        params: {
            code: code
        }
    });
};

var signUpSetPassword = function signUpSetPassword(password) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        url: 'user/registerUser',
        method: 'post',
        params: {
            password: password
        }
    });
};

var uploadProfile = function uploadProfile(form) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        url: 'user/uploadAvatarImg',
        method: 'post',
        data: form,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    });
};

var editUserInfo = function editUserInfo(nickname, gender) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        url: 'user/editUserInfo',
        method: 'post',
        params: {
            nickname: nickname,
            gender: gender
        }
    });
};

var changePhone = function changePhone(code, phone) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        url: 'user/changePhone',
        method: 'post',
        params: {
            code: code,
            phone: phone
        }
    });
};

var orgList = function orgList() {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()('org/orgList');
};

var bindingCard = function bindingCard(org_id, cardno, cardpwd) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        url: 'user/bindingCard',
        method: 'post',
        params: {
            org_id: org_id,
            cardno: cardno,
            cardpwd: cardpwd
        }
    });
};

var messageList = function messageList(page, rows) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        url: 'user/messageList',
        params: {
            page: page,
            rows: rows
        }
    });
};

var isBinding = function isBinding(user_id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        url: 'user/isBinding'
    });
};

var addAddress = function addAddress(name, phone, address, province_code, city_code, area_code, is_default) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        url: 'user/editAddress',
        params: {
            name: name,
            phone: phone,
            address: address,
            province_code: province_code,
            city_code: city_code,
            area_code: area_code,
            is_default: is_default
        }
    });
};

var editAddress = function editAddress(address_id, name, phone, address, province_code, city_code, area_code, is_default) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        url: 'user/editAddress/' + address_id,
        params: {
            name: name,
            phone: phone,
            address: address,
            province_code: province_code,
            city_code: city_code,
            area_code: area_code,
            is_default: is_default
        }
    });
};

var deleteAddress = function deleteAddress(address_id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        url: 'user/deleteAddress/' + address_id
    });
};

var unbunding = function unbunding() {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        url: 'user/unbunding'
    });
};

var setDefAddress = function setDefAddress(address_id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        url: 'user/setDefAddress/' + address_id
    });
};

var addressInfo = function addressInfo(address_id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        url: 'user/addressInfo/' + address_id
    });
};

var resetPassword = function resetPassword(password) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        url: 'user/resetPassword',
        method: 'post',
        params: {
            password: password
        }
    });
};

var changePassword = function changePassword(oldPassword, password) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        url: 'user/changePassword',
        method: 'post',
        params: {
            password: password,
            oldPassword: oldPassword
        }
    });
};

var addBookshelf = function addBookshelf(book_id, user_id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        url: 'user/addBookshelf/' + book_id
    });
};

var specialBookList = function specialBookList(code) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        url: 'book/specialBookList/' + code
    });
};

var getOnlinecard = function getOnlinecard() {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()('ecard');
};

var beginOnlinecard = function beginOnlinecard(org_id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        url: 'ecard/subOrg',
        method: 'get',
        params: {
            org_id: org_id
        }
    });
};

var getonlinecardRule = function getonlinecardRule(user_id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()('ecard/rule' + '?user_id=' + user_id);
};

var onlinecardInfo = function onlinecardInfo(name, gender, idno, mobile, address, job, education) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        url: 'ecard/subInfo',
        method: 'get',
        params: {
            name: name,
            gender: gender,
            idno: idno,
            mobile: mobile,
            address: address,
            job: job,
            education: education
        }
    });
};

var UpLoadCardfile = function UpLoadCardfile(form) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        url: 'ecard/subIdimg',
        method: 'post',
        data: form,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    });
};

var wxpay = function wxpay(userid) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        url: 'weixin/wxpay',
        method: 'post',
        params: {
            userid: userid
        }
    });
};

var getEcardFee = function getEcardFee(userid) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        url: 'v4/ecard/getEcardFee',
        params: {
            userid: userid
        }
    });
};

var payOk = function payOk(userid) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        url: 'ecard/payOk',
        params: {
            userid: userid
        }
    });
};

var confirmSignup = function confirmSignup(borrow_id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        url: 'borrow/confirmSignup',
        method: 'post',
        params: {
            borrow_id: borrow_id
        }
    });
};

var tipIndex = function tipIndex() {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()('tipIndex');
};

var getOrderDetail = function getOrderDetail() {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()('ecard/ecardorderDetail');
};

var hasEcardOrgList = function hasEcardOrgList() {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()('org/hasEcardOrgList');
};

var sharePoint = function sharePoint() {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default()('mall/addPointByShare');
};



/***/ }),
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_personalcenter_children_personalInfo_index__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_personalcenter_children_personalInfo_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_personalcenter_children_personalInfo_index__);




var systemMaintenance = function systemMaintenance(r) {
    return __webpack_require__.e/* require.ensure */(51).then((function () {
        return r(__webpack_require__(250));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var first = function first(r) {
    return __webpack_require__.e/* require.ensure */(22).then((function () {
        return r(__webpack_require__(206));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var second = function second(r) {
    return __webpack_require__.e/* require.ensure */(34).then((function () {
        return r(__webpack_require__(244));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var third = function third(r) {
    return __webpack_require__.e/* require.ensure */(25).then((function () {
        return r(__webpack_require__(251));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var onlinecard = function onlinecard(r) {
    return __webpack_require__.e/* require.ensure */(44).then((function () {
        return r(__webpack_require__(214));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var writePersonInfo = function writePersonInfo(r) {
    return __webpack_require__.e/* require.ensure */(5).then((function () {
        return r(__webpack_require__(213));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var uploadCertPhoto = function uploadCertPhoto(r) {
    return __webpack_require__.e/* require.ensure */(29).then((function () {
        return r(__webpack_require__(212));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var payDeposit = function payDeposit(r) {
    return __webpack_require__.e/* require.ensure */(30).then((function () {
        return r(__webpack_require__(211));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var orderPaySuccess = function orderPaySuccess(r) {
    return __webpack_require__.e/* require.ensure */(31).then((function () {
        return r(__webpack_require__(210));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var noUploadPhoto = function noUploadPhoto(r) {
    return __webpack_require__.e/* require.ensure */(32).then((function () {
        return r(__webpack_require__(208));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var onlinecardNotice = function onlinecardNotice(r) {
    return __webpack_require__.e/* require.ensure */(36).then((function () {
        return r(__webpack_require__(209));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var pointcity = function pointcity(r) {
    return __webpack_require__.e/* require.ensure */(26).then((function () {
        return r(__webpack_require__(238));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var myExchange = function myExchange(r) {
    return __webpack_require__.e/* require.ensure */(28).then((function () {
        return r(__webpack_require__(234));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var integralRule = function integralRule(r) {
    return __webpack_require__.e/* require.ensure */(35).then((function () {
        return r(__webpack_require__(233));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var integralDetail = function integralDetail(r) {
    return __webpack_require__.e/* require.ensure */(45).then((function () {
        return r(__webpack_require__(232));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var taskCenter = function taskCenter(r) {
    return __webpack_require__.e/* require.ensure */(42).then((function () {
        return r(__webpack_require__(237));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var prizePage = function prizePage(r) {
    return __webpack_require__.e/* require.ensure */(0).then((function () {
        return r(__webpack_require__(86));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var prizeDetail = function prizeDetail(r) {
    return __webpack_require__.e/* require.ensure */(0/* duplicate */).then((function () {
        return r(__webpack_require__(86));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var exchangeSuccess = function exchangeSuccess(r) {
    return __webpack_require__.e/* require.ensure */(41).then((function () {
        return r(__webpack_require__(236));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var exchangeOrder = function exchangeOrder(r) {
    return __webpack_require__.e/* require.ensure */(27).then((function () {
        return r(__webpack_require__(235));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var bookcity = function bookcity(r) {
    return __webpack_require__.e/* require.ensure */(4).then((function () {
        return r(__webpack_require__(205));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var bookPage = function bookPage(r) {
    return __webpack_require__.e/* require.ensure */(57).then((function () {
        return r(__webpack_require__(199));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var bookOrder = function bookOrder(r) {
    return __webpack_require__.e/* require.ensure */(23).then((function () {
        return r(__webpack_require__(195));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var bookOrderSuccess = function bookOrderSuccess(r) {
    return __webpack_require__.e/* require.ensure */(1).then((function () {
        return r(__webpack_require__(196));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var rankList = function rankList(r) {
    return __webpack_require__.e/* require.ensure */(10).then((function () {
        return r(__webpack_require__(203));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var subjectBookList = function subjectBookList(r) {
    return __webpack_require__.e/* require.ensure */(16).then((function () {
        return r(__webpack_require__(204));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var catagray = function catagray(r) {
    return __webpack_require__.e/* require.ensure */(56).then((function () {
        return r(__webpack_require__(201));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var catagrayBookList = function catagrayBookList(r) {
    return __webpack_require__.e/* require.ensure */(11).then((function () {
        return r(__webpack_require__(200));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var messageDetail = function messageDetail(r) {
    return __webpack_require__.e/* require.ensure */(47).then((function () {
        return r(__webpack_require__(202));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var chooseBookNum = function chooseBookNum(r) {
    return __webpack_require__.e/* require.ensure */(39).then((function () {
        return r(__webpack_require__(197));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var personalcenter = function personalcenter(r) {
    return __webpack_require__.e/* require.ensure */(46).then((function () {
        return r(__webpack_require__(231));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var changeNick = function changeNick(r) {
    return __webpack_require__.e/* require.ensure */(20).then((function () {
        return r(__webpack_require__(224));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var changePhone = function changePhone(r) {
    return __webpack_require__.e/* require.ensure */(48).then((function () {
        return r(__webpack_require__(225));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var updatePhone = function updatePhone(r) {
    return __webpack_require__.e/* require.ensure */(15).then((function () {
        return r(__webpack_require__(226));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var myReadCard = function myReadCard(r) {
    return __webpack_require__.e/* require.ensure */(37).then((function () {
        return r(__webpack_require__(223));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var myBorrow = function myBorrow(r) {
    return __webpack_require__.e/* require.ensure */(13).then((function () {
        return r(__webpack_require__(222));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var logisticalInfo = function logisticalInfo(r) {
    return __webpack_require__.e/* require.ensure */(24).then((function () {
        return r(__webpack_require__(220));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var orderDetails = function orderDetails(r) {
    return __webpack_require__.e/* require.ensure */(43).then((function () {
        return r(__webpack_require__(221));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var myBookcase = function myBookcase(r) {
    return __webpack_require__.e/* require.ensure */(6).then((function () {
        return r(__webpack_require__(219));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var myAddress = function myAddress(r) {
    return __webpack_require__.e/* require.ensure */(40).then((function () {
        return r(__webpack_require__(218));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var addNewAddress = function addNewAddress(r) {
    return __webpack_require__.e/* require.ensure */(3).then((function () {
        return r(__webpack_require__(216));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var editorAddress = function editorAddress(r) {
    return __webpack_require__.e/* require.ensure */(2).then((function () {
        return r(__webpack_require__(217));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var readerHelp = function readerHelp(r) {
    return __webpack_require__.e/* require.ensure */(53).then((function () {
        return r(__webpack_require__(230));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var oftenQuestion = function oftenQuestion(r) {
    return __webpack_require__.e/* require.ensure */(50).then((function () {
        return r(__webpack_require__(227));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var onlineCardSet = function onlineCardSet(r) {
    return __webpack_require__.e/* require.ensure */(55).then((function () {
        return r(__webpack_require__(228));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var onlineService = function onlineService(r) {
    return __webpack_require__.e/* require.ensure */(54).then((function () {
        return r(__webpack_require__(229));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var message = function message(r) {
    return __webpack_require__.e/* require.ensure */(18).then((function () {
        return r(__webpack_require__(215));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var selecterAddress = function selecterAddress(r) {
    return __webpack_require__.e/* require.ensure */(38).then((function () {
        return r(__webpack_require__(198));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var searchWrap = function searchWrap(r) {
    return __webpack_require__.e/* require.ensure */(33).then((function () {
        return r(__webpack_require__(243));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var search = function search(r) {
    return __webpack_require__.e/* require.ensure */(49).then((function () {
        return r(__webpack_require__(239));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var searchResult = function searchResult(r) {
    return __webpack_require__.e/* require.ensure */(9).then((function () {
        return r(__webpack_require__(242));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var bindingCard = function bindingCard(r) {
    return __webpack_require__.e/* require.ensure */(12).then((function () {
        return r(__webpack_require__(194));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var lackBook = function lackBook(r) {
    return __webpack_require__.e/* require.ensure */(19).then((function () {
        return r(__webpack_require__(240));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var lackBookHistory = function lackBookHistory(r) {
    return __webpack_require__.e/* require.ensure */(21).then((function () {
        return r(__webpack_require__(241));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var validatePhone = function validatePhone(r) {
    return __webpack_require__.e/* require.ensure */(14).then((function () {
        return r(__webpack_require__(249));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var signupSetPassword = function signupSetPassword(r) {
    return __webpack_require__.e/* require.ensure */(7).then((function () {
        return r(__webpack_require__(247));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var changePassword = function changePassword(r) {
    return __webpack_require__.e/* require.ensure */(8).then((function () {
        return r(__webpack_require__(245));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var login = function login(r) {
    return __webpack_require__.e/* require.ensure */(17).then((function () {
        return r(__webpack_require__(246));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var userAgreement = function userAgreement(r) {
    return __webpack_require__.e/* require.ensure */(58).then((function () {
        return r(__webpack_require__(248));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var index = function index(r) {
    return __webpack_require__.e/* require.ensure */(52).then((function () {
        return r(__webpack_require__(207));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = [{
    path: '/',
    component: first,
    children: [{
        path: '',
        component: bookcity
    }, {
        path: 'onlinecard',
        component: onlinecard
    }, {
        path: 'pointcity',
        component: pointcity
    }, {
        path: 'personalcenter',
        component: personalcenter
    }]
}, {
    path: 'second',
    component: second,
    children: [{
        path: '/onlinecard/writePersonInfo',
        component: writePersonInfo
    }, {
        path: '/onlinecard/onlinecardNotice',
        component: onlinecardNotice
    }, {
        path: '/onlinecard/uploadCertPhoto',
        component: uploadCertPhoto
    }, {
        path: '/onlinecard/payDeposit/',
        component: payDeposit
    }, {
        path: '/onlinecard/orderPaySuccess/:statu_id',
        component: orderPaySuccess
    }, {
        path: '/onlinecard/noUploadPhoto/:error_id',
        component: noUploadPhoto
    }, {
        path: '/personalcenter/personalinfo',
        component: __WEBPACK_IMPORTED_MODULE_2__pages_personalcenter_children_personalInfo_index___default.a
    }, {
        path: '/personalcenter/personalinfo/changenick',
        component: changeNick
    }, {
        path: '/personalcenter/personalinfo/changephone',
        component: changePhone
    }, {
        path: '/personalcenter/personalinfo/updatephone/:type',
        component: updatePhone
    }, {
        path: '/personalcenter/myreadcard',
        component: myReadCard
    }, {
        path: '/personalcenter/myborrow',
        component: myBorrow
    }, {
        path: '/personalcenter/myborrow/logisticalinfo/:expressorder_id',
        component: logisticalInfo
    }, {
        path: '/personalcenter/myborrow/orderDetails/:borroworder_id',
        component: orderDetails
    }, {
        path: '/personalcenter/mybookcase',
        component: myBookcase
    }, {
        path: '/personalcenter/myaddress/addnewaddress',
        component: addNewAddress
    }, {
        path: '/personalcenter/myaddress/editoraddress/:id',
        component: editorAddress
    }, {
        path: '/personalcenter/readerhelp',
        component: readerHelp
    }, {
        path: '/personalcenter/readerhelp/oftenquestion',
        component: oftenQuestion
    }, {
        path: '/personalcenter/readerhelp/onlinecardset',
        component: onlineCardSet
    }, {
        path: '/personalcenter/readerhelp/onlineservice',
        component: onlineService
    }, {
        path: '/personalcenter/message',
        component: message
    }, {
        path: '/pointcity/myexchange',
        component: myExchange
    }, {
        path: '/pointcity/integralrule',
        component: integralRule
    }, {
        path: '/pointcity/taskcenter',
        component: taskCenter
    }, {
        path: '/pointcity/integraldetail',
        component: integralDetail
    }, {
        path: '/pointcity/prizepage/:id',
        component: prizePage
    }, {
        path: '/pointcity/integraldetail',
        component: integralDetail
    }, {
        path: '/prizepage/exchangesuccess/:id',
        component: exchangeSuccess
    }, {
        path: '/prizepage/:address_id/exchangeorder/:id',
        component: exchangeOrder
    }, {
        path: '/bookcity/bookpage/:book_id/bookorder/:address_id',
        component: bookOrder
    }, {
        path: '/bookcity/bookpage/:book_id/bookordersuccess/:order_id',
        component: bookOrderSuccess
    }, {
        path: '/bookcity/bookpage/:book_id/chooseBookNum',
        component: chooseBookNum
    }, {
        path: '/bookcity/ranklist/:code',
        component: rankList
    }, {
        path: '/bookcity/subjectbooklist/:subject_id',
        component: subjectBookList
    }, {
        path: '/bookcity/catagray',
        component: catagray
    }, {
        path: '/bookcity/catagray/catagraybooklist/:clc_code',
        component: catagrayBookList
    }, {
        path: '/bookcity/message/messagedetail/:article_id',
        component: messageDetail
    }, {
        path: '/bindingcard/bindingcard/:id',
        component: bindingCard
    }, {
        path: '/lackbook',
        component: lackBook
    }, {
        path: '/lackbookhistory',
        component: lackBookHistory
    }, {
        path: '/login',
        component: login
    }, {
        path: '/validatephone/:type',
        component: validatePhone
    }, {
        path: '/signupsetpassword',
        component: signupSetPassword
    }, {
        path: '/changepassword',
        component: changePassword
    }]
}, {
    path: 'third',
    component: third,
    children: [{
        path: '/bookcity/bookpage/:book_id',
        component: bookPage
    }, {
        path: '/personalcenter/myaddress',
        component: myAddress
    }]
}, {
    path: "/search",
    component: searchWrap,
    children: [{
        name: 'search',
        path: '',
        component: search
    }, {
        name: 'searchResult',
        path: 'searchresult/:keyWord',
        component: searchResult
    }]
}, {
    path: "/selecteraddress/:order_type/:goods_id",
    component: selecterAddress
}, {
    path: '/systemMaintenance',
    component: systemMaintenance
}, {
    path: '/useragreement',
    component: userAgreement
}, {
    path: '/index',
    component: index
}];

/* harmony default export */ __webpack_exports__["a"] = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    routes: router,
    mode: 'hash'
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(104);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    state: __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */],
    mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* default */],
    actions: __WEBPACK_IMPORTED_MODULE_4__actions__["a" /* default */]
});

/* harmony default export */ __webpack_exports__["a"] = store;

/***/ }),
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(160)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(115),
  /* template */
  __webpack_require__(174),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_searchInputValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_title; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_tabbarIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_userSexMan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_userSexWomen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_userSexDefault; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_userAddress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return UPDATE_loadingStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SET_avatar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SET_name; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SET_nickName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SET_mobile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return SET_orgLogo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return SET_baseurl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SET_userLoginOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SET_userLoginIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SET_userBindingOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SET_userBindingIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return SET_type; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return SET_orgName; });
var SET_searchInputValue = 'SET_SEARCH_INPUT_VALUE';
var SET_title = 'SET_TITLE';
var SET_tabbarIndex = 'SET_TABBAR_INDEX';
var SET_userSexMan = 'SET_USER_SEX_MAN';
var SET_userSexWomen = 'SET_USER_SEX_WOMEN';
var SET_userSexDefault = 'SET_USER_SEX_DEFAULT';
var SET_userAddress = 'SET_USER_ADDRESS';
var UPDATE_loadingStatus = 'UPDATE_LOADING_STATUS';
var SET_avatar = 'SET_AVATAR';
var SET_name = 'SET_NAME';
var SET_nickName = 'SET_NICKNAME';
var SET_mobile = 'SET_MOBILE';
var SET_orgLogo = 'SET_ORGLOGO';
var SET_baseurl = 'SET_BASEURL';
var SET_userLoginOut = 'SET_USER_LOGIN_OUT';
var SET_userLoginIn = 'SET_USER_LOGIN_IN';
var SET_userBindingOut = 'SET_USER_BINDING_OUT';
var SET_userBindingIn = 'SET_USER_BINDING_IN';
var SET_type = 'SET_TYPE';
var SET_orgName = 'SET_ORGNAME';

/***/ }),
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(162)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(116),
  /* template */
  __webpack_require__(176),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(164)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(111),
  /* template */
  __webpack_require__(178),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(165)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(114),
  /* template */
  __webpack_require__(179),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 71 */,
/* 72 */,
/* 73 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(170)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(109),
  /* template */
  __webpack_require__(184),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(161)

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(175),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(159)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(107),
  /* template */
  __webpack_require__(173),
  /* scopeId */
  null,
  /* cssModules */
  null
)


module.exports = Component.exports


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(163)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(112),
  /* template */
  __webpack_require__(177),
  /* scopeId */
  null,
  /* cssModules */
  null
)


module.exports = Component.exports


/***/ }),
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(166)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(108),
  /* template */
  __webpack_require__(180),
  /* scopeId */
  null,
  /* cssModules */
  null
)


module.exports = Component.exports


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(158)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(110),
  /* template */
  __webpack_require__(172),
  /* scopeId */
  null,
  /* cssModules */
  null
)


module.exports = Component.exports


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(167)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(113),
  /* template */
  __webpack_require__(181),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations_type__ = __webpack_require__(50);


var _SET_searchInputValue;



/* harmony default export */ __webpack_exports__["a"] = _SET_searchInputValue = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_searchInputValue, __WEBPACK_IMPORTED_MODULE_1__mutations_type__["a" /* SET_searchInputValue */], function (_ref, searchValue) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutations_type__["a" /* SET_searchInputValue */], searchValue);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_searchInputValue, __WEBPACK_IMPORTED_MODULE_1__mutations_type__["b" /* SET_title */], function (_ref2, title) {
    var commit = _ref2.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutations_type__["b" /* SET_title */], title);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_searchInputValue, __WEBPACK_IMPORTED_MODULE_1__mutations_type__["c" /* SET_tabbarIndex */], function (_ref3, index) {
    var commit = _ref3.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutations_type__["c" /* SET_tabbarIndex */], index);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_searchInputValue, __WEBPACK_IMPORTED_MODULE_1__mutations_type__["d" /* SET_userSexMan */], function (_ref4) {
    var commit = _ref4.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutations_type__["d" /* SET_userSexMan */]);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_searchInputValue, __WEBPACK_IMPORTED_MODULE_1__mutations_type__["e" /* SET_userSexWomen */], function (_ref5) {
    var commit = _ref5.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutations_type__["e" /* SET_userSexWomen */]);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_searchInputValue, __WEBPACK_IMPORTED_MODULE_1__mutations_type__["f" /* SET_userSexDefault */], function (_ref6) {
    var commit = _ref6.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutations_type__["f" /* SET_userSexDefault */]);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_searchInputValue, __WEBPACK_IMPORTED_MODULE_1__mutations_type__["g" /* SET_userAddress */], function (_ref7, address) {
    var commit = _ref7.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutations_type__["g" /* SET_userAddress */], address);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_searchInputValue, __WEBPACK_IMPORTED_MODULE_1__mutations_type__["h" /* UPDATE_loadingStatus */], function (_ref8, payload) {
    var commit = _ref8.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutations_type__["h" /* UPDATE_loadingStatus */], payload);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_searchInputValue, __WEBPACK_IMPORTED_MODULE_1__mutations_type__["i" /* SET_avatar */], function (_ref9, avatar) {
    var commit = _ref9.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutations_type__["i" /* SET_avatar */], avatar);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_searchInputValue, __WEBPACK_IMPORTED_MODULE_1__mutations_type__["j" /* SET_name */], function (_ref10, name) {
    var commit = _ref10.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutations_type__["j" /* SET_name */], name);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_searchInputValue, __WEBPACK_IMPORTED_MODULE_1__mutations_type__["k" /* SET_nickName */], function (_ref11, nickname) {
    var commit = _ref11.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutations_type__["k" /* SET_nickName */], nickname);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_searchInputValue, __WEBPACK_IMPORTED_MODULE_1__mutations_type__["l" /* SET_mobile */], function (_ref12, mobile) {
    var commit = _ref12.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutations_type__["l" /* SET_mobile */], mobile);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_searchInputValue, __WEBPACK_IMPORTED_MODULE_1__mutations_type__["m" /* SET_userLoginIn */], function (_ref13) {
    var commit = _ref13.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutations_type__["m" /* SET_userLoginIn */]);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_searchInputValue, __WEBPACK_IMPORTED_MODULE_1__mutations_type__["n" /* SET_userLoginOut */], function (_ref14) {
    var commit = _ref14.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutations_type__["n" /* SET_userLoginOut */]);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_searchInputValue, __WEBPACK_IMPORTED_MODULE_1__mutations_type__["o" /* SET_userBindingIn */], function (_ref15) {
    var commit = _ref15.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutations_type__["o" /* SET_userBindingIn */]);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_searchInputValue, __WEBPACK_IMPORTED_MODULE_1__mutations_type__["p" /* SET_userBindingOut */], function (_ref16) {
    var commit = _ref16.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutations_type__["p" /* SET_userBindingOut */]);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_searchInputValue, __WEBPACK_IMPORTED_MODULE_1__mutations_type__["q" /* SET_type */], function (_ref17, type) {
    var commit = _ref17.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutations_type__["q" /* SET_type */], type);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_searchInputValue, __WEBPACK_IMPORTED_MODULE_1__mutations_type__["r" /* SET_orgLogo */], function (_ref18, orgLogoUrl) {
    var commit = _ref18.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutations_type__["r" /* SET_orgLogo */], orgLogoUrl);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_searchInputValue, __WEBPACK_IMPORTED_MODULE_1__mutations_type__["s" /* SET_baseurl */], function (_ref19, baseurl) {
    var commit = _ref19.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutations_type__["s" /* SET_baseurl */], baseurl);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_searchInputValue, __WEBPACK_IMPORTED_MODULE_1__mutations_type__["t" /* SET_orgName */], function (_ref20, orgName) {
    var commit = _ref20.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutations_type__["t" /* SET_orgName */], orgName);
}), _SET_searchInputValue;

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations_type__ = __webpack_require__(50);


var _mutations;



var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutations_type__["a" /* SET_searchInputValue */], function (state, searchValue) {
    state.searchInputValue = searchValue;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutations_type__["b" /* SET_title */], function (state, title) {
    state.title = title;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutations_type__["c" /* SET_tabbarIndex */], function (state, index) {
    state.tabbarIndex = index;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutations_type__["d" /* SET_userSexMan */], function (state) {
    state.userSex = '男';
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutations_type__["e" /* SET_userSexWomen */], function (state) {
    state.userSex = '女';
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutations_type__["f" /* SET_userSexDefault */], function (state) {
    state.userSex = '请选择性别';
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutations_type__["g" /* SET_userAddress */], function (state, address) {
    state.userAddress = address;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutations_type__["h" /* UPDATE_loadingStatus */], function (state, payload) {
    state.isLoading = payload.isLoading;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutations_type__["i" /* SET_avatar */], function (state, avatar) {
    state.avatar = avatar;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutations_type__["j" /* SET_name */], function (state, name) {
    state.name = name;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutations_type__["k" /* SET_nickName */], function (state, nickname) {
    state.nickname = nickname;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutations_type__["l" /* SET_mobile */], function (state, mobile) {
    state.mobile = mobile;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutations_type__["m" /* SET_userLoginIn */], function (state) {
    state.userLogin = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutations_type__["n" /* SET_userLoginOut */], function (state) {
    state.userLogin = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutations_type__["o" /* SET_userBindingIn */], function (state) {
    state.userBinding = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutations_type__["p" /* SET_userBindingOut */], function (state) {
    state.userBinding = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutations_type__["q" /* SET_type */], function (state, type) {
    state.type = type;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutations_type__["r" /* SET_orgLogo */], function (state, orgLogoUrl) {
    state.orgLogo = orgLogoUrl;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutations_type__["s" /* SET_baseurl */], function (state, baseurl) {
    state.baseurl = baseurl;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutations_type__["t" /* SET_orgName */], function (state, orgName) {
    state.orgName = orgName;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = mutations;

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
    searchInputValue: '',
    title: '你看书我买单',
    tabbarIndex: 0,
    userSex: '请选择性别',
    userLogin: true,
    userBinding: false,
    userAddress: null,
    isLoading: false,
    book: {
        bookExt: {}
    },
    avatar: '/style/imgs/mrtx.png',
    name: '您还没有书堆号',
    nickname: '您尚未登录，点击登录',
    mobile: '',
    baseurl: 'http://sdr.shuduier.cn',
    type: 0,
    orgLogo: '',
    orgName: '书堆儿'
};

/* harmony default export */ __webpack_exports__["a"] = state;

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.$tabbar = document.querySelector('.weui-tabbar');
    });
  },

  props: {
    value: Boolean,
    showCancel: Boolean,
    cancelText: String,
    menus: {
      type: [Object, Array],
      default: function _default() {
        return {};
      }
    },
    closeOnClickingMask: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      show: false
    };
  },

  methods: {
    onMenuClick: function onMenuClick(text, key) {
      if (typeof text === 'string') {
        this.emitEvent('on-click-menu', key);
      } else {
        if (text.type !== 'disabled' && text.type !== 'info') {
          if (text.value) {
            this.emitEvent('on-click-menu', text.value);
          } else {
            this.show = false;
          }
        }
      }
    },
    onClickingMask: function onClickingMask() {
      this.closeOnClickingMask && (this.show = false);
    },
    emitEvent: function emitEvent(event, menu) {
      var shouldClose = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      if (event === 'on-click-menu' && !/.noop/.test(menu)) {
        this.$emit(event, menu);
        this.$emit(event + '-' + menu);
        shouldClose && (this.show = false);
      }
    },
    fixIos: function fixIos(zIndex) {
      if (this.$tabbar && /iphone/i.test(navigator.userAgent)) {
        this.$tabbar.style.zIndex = zIndex;
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this2 = this;

      this.$emit('input', val);
      if (val) {
        this.fixIos(-1);
      } else {
        setTimeout(function () {
          _this2.fixIos(100);
        }, 200);
      }
    },

    value: {
      handler: function handler(val) {
        this.show = val;
      },
      immediate: true
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.fixIos(100);
  }
};

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__x_dialog__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__x_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__x_dialog__);




/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    XDialog: __WEBPACK_IMPORTED_MODULE_0__x_dialog___default.a
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    buttonText: String,
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    }
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
};

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inline_desc__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inline_desc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__inline_desc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_router__ = __webpack_require__(71);





/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    InlineDesc: __WEBPACK_IMPORTED_MODULE_0__inline_desc___default.a
  },
  props: {
    title: String,
    value: [String, Number, Array],
    isLink: Boolean,
    inlineDesc: [String, Number],
    primary: {
      type: String,
      default: 'title'
    },
    link: {
      type: [String, Object]
    }
  },
  methods: {
    onClick: function onClick() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__libs_router__["a" /* go */])(this.link, this.$router);
    }
  }
};

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__x_dialog__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__x_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__x_dialog__);



/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    XDialog: __WEBPACK_IMPORTED_MODULE_0__x_dialog___default.a
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    title: String,
    confirmText: String,
    cancelText: String,
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    content: String
  },
  created: function created() {
    this.showValue = this.show;
    if (this.value) {
      this.showValue = this.value;
    }
  },

  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onConfirm: function _onConfirm() {
      this.showValue = false;
      this.$emit('on-confirm');
    },
    _onCancel: function _onCancel() {
      this.showValue = false;
      this.$emit('on-cancel');
    }
  }
};

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  props: {
    title: String,
    titleColor: String,
    labelWidth: String,
    labelAlign: String,
    labelMarginRight: String,
    gutter: String
  }
};

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  created: function created() {
    this.show = this.value;
  },
  data: function data() {
    return {
      show: false
    };
  },

  watch: {
    value: function value(val) {
      this.show = val;
    },
    show: function show(val) {
      this.$emit('input', val);
    }
  }
};

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_safari_fix__ = __webpack_require__(119);




/* harmony default export */ __webpack_exports__["default"] = {
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_safari_fix__["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      this.fixSafariOverflowScrolling('auto');

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
      }
      if (val) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
};

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  props: {
    type: {
      default: 'default'
    },
    disabled: Boolean,
    mini: Boolean,
    plain: Boolean,
    text: String,
    actionType: String,
    showLoading: Boolean
  },
  computed: {
    classes: function classes() {
      return [{
        'weui-btn_disabled': this.disabled,
        'weui-btn_mini': this.mini
      }, 'weui-btn_' + this.type, this.plain ? 'weui-btn_plain-' + this.type : '', this.showLoading ? 'weui-btn_loading' : ''];
    }
  }
};

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    hideOnBlur: Boolean,
    scroll: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.currentValue = this.value;
    }
  },

  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(val) {
      this.$emit(val ? 'on-show' : 'on-hide');
      this.$emit('input', val);
    }
  },
  data: function data() {
    return {
      currentValue: false
    };
  },

  methods: {
    onTouchMove: function onTouchMove(event) {
      !this.scroll && event.preventDefault();
    }
  }
};

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vux_src_components_loading_index_vue__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vux_src_components_loading_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vux_src_components_loading_index_vue__);



/* harmony default export */ __webpack_exports__["default"] = {
  name: 'app',
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_0_vux_src_components_loading_index_vue___default.a
  },
  computed: {
    isLoading: function isLoading() {
      return this.$store.state.isLoading;
    }
  }
};

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cropperjs__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cropperjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_cropperjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service_getData__ = __webpack_require__(14);





/* harmony default export */ __webpack_exports__["default"] = {
    name: 'upload-img',
    data: function data() {
        return {
            img: '',
            imgsrc: '',
            crop: false,
            cropper: null
        };
    },

    methods: {
        readImg: function readImg(e) {
            var self = this;
            var file = e.target.files[0];
            console.log(file);
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function (e) {
                self.imgsrc = this.result;
                var imgD = document.getElementById('img');
                console.log(__WEBPACK_IMPORTED_MODULE_0_cropperjs___default.a);
                imgD.onload = function () {
                    var cropper = new __WEBPACK_IMPORTED_MODULE_0_cropperjs___default.a(imgD, {
                        aspectRatio: 1 / 1,
                        viewMode: 1,
                        dragMode: 'move',
                        cropBoxMovable: false,
                        cropBoxResizable: false,
                        minCropBoxHeight: 100,
                        minCropBoxWidth: 100,
                        minContainerWidth: window.screen.width,
                        minContainerHeight: window.screen.height
                    });
                    self.cropper = cropper;
                    self.crop = true;
                };
            };
        },
        upload: function upload() {
            var self = this;
            if (self.cropper) {
                alert('cropper' + self.cropper);
                self.cropper.getCroppedCanvas({ width: 100, height: 100 }).toBlob(function (blob) {
                    alert('blob' + blob.toString());
                    var form = new FormData();
                    form.append('avatarImg', blob, 'image.png');
                    alert('form' + form.toString());
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__service_getData__["_18" /* uploadProfile */])(form).then(function (res) {
                        alert('res' + res.toString());
                        if (res.data.status) {
                            var avatar = res.data.avatarImgUrl + '?' + Date.parse(new Date());
                            self.$store.dispatch('SET_AVATAR', avatar);
                            self.crop = false;
                            self.cropper.destroy();
                        }
                        console.log(res);
                    }).catch(function (error) {
                        console.log(error);
                    });
                });
            }
        }
    }
};

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vux_src_components_group_index_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vux_src_components_group_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vux_src_components_group_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_cell_index_vue__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_components_cell_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vux_src_components_cell_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_actionsheet_index_vue__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_components_actionsheet_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vux_src_components_actionsheet_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_button_index_vue__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_button_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_button_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_UpLoadProfile_index__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_UpLoadProfile_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_UpLoadProfile_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__service_getData__ = __webpack_require__(14);









/* harmony default export */ __webpack_exports__["default"] = {
    mounted: function mounted() {
        this.$store.dispatch('SET_TITLE', '个人信息');
    },

    components: {
        Group: __WEBPACK_IMPORTED_MODULE_0_vux_src_components_group_index_vue___default.a,
        Cell: __WEBPACK_IMPORTED_MODULE_1_vux_src_components_cell_index_vue___default.a,
        Actionsheet: __WEBPACK_IMPORTED_MODULE_2_vux_src_components_actionsheet_index_vue___default.a,
        XButton: __WEBPACK_IMPORTED_MODULE_3_vux_src_components_x_button_index_vue___default.a,
        'upload-img': __WEBPACK_IMPORTED_MODULE_4__components_UpLoadProfile_index___default.a
    },
    data: function data() {
        return {
            showsex: false,
            sexmenus: {
                man: '男',
                women: '女'
            },
            showprofile: false,
            profilemenus: [{
                label: '<label style="display: inline-block;width: 100%;" for="upload_input">选择照片</label>'
            }],
            showWithdrew: true,
            showMessage: true
        };
    },

    methods: {
        choiceSex: function choiceSex() {
            this.showsex = true;
        },
        changeSex: function changeSex(menuKey) {
            var self = this;
            var nickname = self.$store.state.nickname;
            if (menuKey === 'man') {
                var gender = 1;
            } else {
                var gender = 2;
            }
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__service_getData__["M" /* editUserInfo */])(nickname, gender).then(function (result) {
                if (result.data.status) {
                    var gender = result.data.userExt.gender;
                    if (1 == gender) {
                        self.$store.dispatch('SET_USER_SEX_MAN');
                    } else if (2 == gender) {
                        self.$store.dispatch('SET_USER_SEX_WOMEN');
                    }
                }
            }).catch(function (err) {
                console.log(err);
            });
        },
        choiceProfile: function choiceProfile() {
            this.showprofile = true;
        },
        closeProfile: function closeProfile() {
            this.showprofile = false;
        },
        link: function link() {
            var self = this;
            this.$vux.confirm.show({
                title: '提示',
                content: '您确定要退出吗',
                onConfirm: function onConfirm() {
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__service_getData__["_17" /* loginOut */])().then(function (res) {
                        if (res.data.status) {
                            self.$store.dispatch('SET_USER_LOGIN_OUT');
                            self.$store.dispatch('SET_AVATAR', '/style/imgs/mrtx.png');
                            self.$store.dispatch('SET_NICKNAME', '您尚未登录，点击登录');
                            self.$store.dispatch('SET_NAME', '您还没有书堆号');
                            self.$router.go(-1);
                        }
                    }).catch(function (err) {
                        console.log(err);
                    });
                }
            });
        }
    },
    computed: {
        sex: function sex() {
            return this.$store.state.userSex;
        },
        avatar: function avatar() {
            return this.$store.state.avatar;
        },
        nickname: function nickname() {
            return this.$store.state.nickname;
        },
        mobile: function mobile() {
            var mobile = this.$store.state.mobile;
            var newmobile = mobile.substr(0, 3) + "****" + mobile.substr(7);
            return newmobile;
        }
    }
};

/***/ }),
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 159 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 160 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 161 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 162 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 163 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 164 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 165 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 166 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 167 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 168 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 169 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 170 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 171 */,
/* 172 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-dialog', {
    attrs: {
      "mask-transition": _vm.maskTransition,
      "dialog-transition": _vm.dialogTransition,
      "hide-on-blur": _vm.hideOnBlur
    },
    on: {
      "on-hide": function($event) {
        _vm.$emit('on-hide')
      },
      "on-show": function($event) {
        _vm.$emit('on-show')
      }
    },
    model: {
      value: (_vm.showValue),
      callback: function($$v) {
        _vm.showValue = $$v
      },
      expression: "showValue"
    }
  }, [_c('div', {
    staticClass: "weui-dialog__hd"
  }, [_c('strong', {
    staticClass: "weui-dialog__title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "weui-dialog__bd"
  }, [_vm._t("default", [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])], 2), _vm._v(" "), _c('div', {
    staticClass: "weui-dialog__ft"
  }, [_c('a', {
    staticClass: "weui-dialog__btn weui-dialog__btn_default",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm._onCancel
    }
  }, [_vm._v(_vm._s(_vm.cancelText || '取消'))]), _vm._v(" "), _c('a', {
    staticClass: "weui-dialog__btn weui-dialog__btn_primary",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm._onConfirm
    }
  }, [_vm._v(_vm._s(_vm.confirmText || '确定'))])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 173 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-actionsheet"
  }, [_c('transition', {
    attrs: {
      "name": "vux-actionsheet-mask"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "weui-mask weui-mask_transparent",
    on: {
      "click": _vm.onClickingMask
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "weui-actionsheet",
    class: {
      'weui-actionsheet_toggle': _vm.show
    }
  }, [_c('div', {
    staticClass: "weui-actionsheet__menu"
  }, _vm._l((_vm.menus), function(text, key) {
    return _c('div', {
      staticClass: "weui-actionsheet__cell",
      class: ("vux-actionsheet-menu-" + (text.type || 'default')),
      domProps: {
        "innerHTML": _vm._s(text.label || text)
      },
      on: {
        "click": function($event) {
          _vm.onMenuClick(text, key)
        }
      }
    })
  })), _vm._v(" "), (_vm.showCancel) ? _c('div', {
    staticClass: "weui-actionsheet__action",
    on: {
      "click": function($event) {
        _vm.emitEvent('on-click-menu', 'cancel')
      }
    }
  }, [_c('div', {
    staticClass: "weui-actionsheet__cell"
  }, [_vm._v(_vm._s(_vm.cancelText || '取消'))])]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 174 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-x-dialog",
    on: {
      "touchmove": _vm.onTouchMove
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.maskTransition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    staticClass: "weui-mask",
    on: {
      "click": function($event) {
        _vm.hideOnBlur && (_vm.currentValue = false)
      }
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.dialogTransition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    staticClass: "weui-dialog"
  }, [_vm._t("default")], 2)])], 1)
},staticRenderFns: []}

/***/ }),
/* 175 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "vux-label-desc"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 176 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "name": "bounce",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('loading', {
    model: {
      value: (_vm.isLoading),
      callback: function($$v) {
        _vm.isLoading = $$v
      },
      expression: "isLoading"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 177 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "vux-mask"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "weui-loading_toast"
  }, [_c('div', {
    staticClass: "weui-mask_transparent"
  }), _vm._v(" "), _c('div', {
    staticClass: "weui-toast",
    style: ({
      position: _vm.position
    })
  }, [_c('i', {
    staticClass: "weui-loading weui-icon_toast"
  }), _vm._v(" "), _c('p', {
    staticClass: "weui-toast__content"
  }, [_vm._v(_vm._s(_vm.text || '加载中')), _vm._t("default")], 2)])])])
},staticRenderFns: []}

/***/ }),
/* 178 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.title) ? _c('div', {
    staticClass: "weui-cells__title",
    style: ({
      color: _vm.titleColor
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "weui-cells",
    class: {
      'vux-no-group-title': !_vm.title
    },
    style: ({
      marginTop: _vm.gutter
    })
  }, [_vm._t("after-title"), _vm._v(" "), _vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 179 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "weui-btn",
    class: _vm.classes,
    attrs: {
      "disabled": _vm.disabled,
      "type": _vm.actionType
    }
  }, [(_vm.showLoading) ? _c('i', {
    staticClass: "weui-loading"
  }) : _vm._e(), _vm._t("default", [_vm._v(_vm._s(_vm.text))])], 2)
},staticRenderFns: []}

/***/ }),
/* 180 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-alert"
  }, [_c('x-dialog', {
    attrs: {
      "mask-transition": _vm.maskTransition,
      "dialog-transition": _vm.dialogTransition
    },
    on: {
      "on-hide": function($event) {
        _vm.$emit('on-hide')
      },
      "on-show": function($event) {
        _vm.$emit('on-show')
      }
    },
    model: {
      value: (_vm.showValue),
      callback: function($$v) {
        _vm.showValue = $$v
      },
      expression: "showValue"
    }
  }, [_c('div', {
    staticClass: "weui-dialog__hd"
  }, [_c('strong', {
    staticClass: "weui-dialog__title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "weui-dialog__bd"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "weui-dialog__ft"
  }, [_c('a', {
    staticClass: "weui-dialog__btn weui-dialog__btn_primary",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm._onHide
    }
  }, [_vm._v(_vm._s(_vm.buttonText || '确定'))])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 181 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-toast"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowMask && _vm.show),
      expression: "isShowMask && show"
    }],
    staticClass: "weui-mask_transparent"
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.currentTransition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "weui-toast",
    class: _vm.toastClass,
    style: ({
      width: _vm.width
    })
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type !== 'text'),
      expression: "type !== 'text'"
    }],
    staticClass: "weui-icon-success-no-circle weui-icon_toast"
  }), _vm._v(" "), (_vm.text) ? _c('p', {
    staticClass: "weui-toast__content",
    style: (_vm.style),
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }) : _c('p', {
    staticClass: "weui-toast__content"
  }, [_vm._t("default")], 2)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 182 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.crop),
      expression: "crop"
    }],
    staticClass: "upload-profile",
    attrs: {
      "id": "crop_wrap"
    }
  }, [_c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "upload_input",
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.readImg
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "img",
      "src": _vm.imgsrc
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "upload-profile-btn"
  }, [_c('div', {
    staticClass: "sure",
    on: {
      "click": _vm.upload
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('div', {
    staticClass: "cancle",
    on: {
      "click": function($event) {
        _vm.cancle()
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 183 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMessage),
      expression: "showMessage"
    }]
  }, [_c('group', [_c('cell', {
    attrs: {
      "title": "头像",
      "is-link": true
    }
  }, [_c('img', {
    staticClass: "user-profile",
    attrs: {
      "src": _vm.$store.state.baseurl + _vm.$store.state.avatar
    }
  })])], 1), _vm._v(" "), _c('group', [_c('cell', {
    attrs: {
      "title": "昵称",
      "is-link": true,
      "link": "/personalcenter/personalinfo/changenick"
    }
  }, [_c('span', {
    staticClass: "info",
    attrs: {
      "title": _vm.nickname
    }
  }, [_vm._v(_vm._s(_vm.nickname))])])], 1), _vm._v(" "), _c('group', [_c('cell', {
    attrs: {
      "title": "性别",
      "is-link": true
    },
    nativeOn: {
      "click": function($event) {
        _vm.choiceSex($event)
      }
    }
  }, [_c('span', {
    staticClass: "info"
  }, [_vm._v(_vm._s(_vm.sex))])])], 1), _vm._v(" "), _c('group', [_c('cell', {
    attrs: {
      "title": "手机号码",
      "is-link": true,
      "link": "/personalcenter/personalinfo/changephone"
    }
  }, [_c('span', {
    staticClass: "info"
  }, [_vm._v(_vm._s(_vm.mobile))])])], 1), _vm._v(" "), _c('group', [_c('cell', {
    attrs: {
      "title": "更改密码",
      "is-link": true,
      "link": "/changepassword"
    }
  }, [_c('span', {
    staticClass: "info"
  })])], 1), _vm._v(" "), _c('group', [_c('x-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showWithdrew),
      expression: "showWithdrew"
    }],
    nativeOn: {
      "click": function($event) {
        _vm.link($event)
      }
    }
  }, [_vm._v("退出登录")])], 1), _vm._v(" "), _c('actionsheet', {
    attrs: {
      "show-cancel": true,
      "menus": _vm.sexmenus
    },
    on: {
      "on-click-menu": _vm.changeSex
    },
    model: {
      value: (_vm.showsex),
      callback: function($$v) {
        _vm.showsex = $$v
      },
      expression: "showsex"
    }
  }), _vm._v(" "), _c('actionsheet', {
    attrs: {
      "show-cancel": true,
      "menus": _vm.profilemenus
    },
    on: {
      "on-click-menu": _vm.closeProfile
    },
    model: {
      value: (_vm.showprofile),
      callback: function($$v) {
        _vm.showprofile = $$v
      },
      expression: "showprofile"
    }
  }), _vm._v(" "), _c('upload-img')], 1)
},staticRenderFns: []}

/***/ }),
/* 184 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-cell",
    class: {
      'vux-tap-active': _vm.isLink || !!_vm.link, 'weui-cell_access': _vm.isLink || !!_vm.link
    },
    on: {
      "click": _vm.onClick
    }
  }, [_c('div', {
    staticClass: "weui-cell__hd"
  }, [_vm._t("icon")], 2), _vm._v(" "), _c('div', {
    staticClass: "vux-cell-bd",
    class: {
      'vux-cell-primary': _vm.primary === 'title'
    }
  }, [_c('p', [_vm._v("\n      " + _vm._s(_vm.title) + "\n      "), _vm._t("after-title")], 2), _vm._v(" "), _c('inline-desc', [_vm._v(_vm._s(_vm.inlineDesc))])], 1), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__ft",
    class: {
      'vux-cell-primary': _vm.primary === 'content'
    }
  }, [_vm._v("\n    " + _vm._s(_vm.value) + "\n    "), _vm._t("value"), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), _vm._t("child")], 2)
},staticRenderFns: []}

/***/ }),
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(168)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(117),
  /* template */
  __webpack_require__(182),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(169)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(118),
  /* template */
  __webpack_require__(183),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 190 */,
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fastclick__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fastclick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fastclick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router_index__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_index__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_plugins_alert_index_js__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vux_src_plugins_confirm_index_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vux_src_plugins_wechat_index_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vux_src_plugins_toast_index_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__service_getData__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_lazyload__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_lazyload__);














var locationUrl = location.href.split('#')[0];
locationUrl = locationUrl.split('?')[0];
var baseUrl = locationUrl.replace('/shuduier/', '');

__WEBPACK_IMPORTED_MODULE_4__store_index__["a" /* default */].dispatch('SET_BASEURL', baseUrl);

console.log(__WEBPACK_IMPORTED_MODULE_4__store_index__["a" /* default */].state.baseurl);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vux_src_plugins_alert_index_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vux_src_plugins_confirm_index_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vux_src_plugins_wechat_index_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10_vue_lazyload___default.a, {
    preLoad: 1.3,
    error: __WEBPACK_IMPORTED_MODULE_4__store_index__["a" /* default */].state.baseurl + '/style/imgs/book_loadimg.png',
    loading: __WEBPACK_IMPORTED_MODULE_4__store_index__["a" /* default */].state.baseurl + '/style/imgs/book_loadimg.png',
    attempt: 1,
    filter: {
        webp: function webp(_ref) {
            var src = _ref.src;

            var isCDN = /http:/;
            var isHttps = /https:/;
            if (!(isCDN.test(src) || isHttps.test(src))) {
                src = __WEBPACK_IMPORTED_MODULE_4__store_index__["a" /* default */].state.baseurl + src;
            }
            return src;
        }
    }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vux_src_plugins_toast_index_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_fastclick___default.a.attach(document.body);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = true;

var setDocumentTitle = function setDocumentTitle(title) {
    document.title = title;
    console.log(title);
    var ua = navigator.userAgent;
    if (/\bMicroMessenger\/([\d\.]+)/.test(ua) && /ip(hone|od|ad)/i.test(ua)) {
        var i = document.createElement('iframe');
        i.src = '/favicon.ico';
        i.style.display = 'none';
        i.onload = function () {
            setTimeout(function () {
                i.remove();
            }, 9);
        };
        document.body.appendChild(i);
    }
};

__WEBPACK_IMPORTED_MODULE_3__router_index__["a" /* default */].beforeEach(function (to, from, next) {
    __WEBPACK_IMPORTED_MODULE_4__store_index__["a" /* default */].dispatch('UPDATE_LOADING_STATUS', { isLoading: true });
    next();
});

__WEBPACK_IMPORTED_MODULE_3__router_index__["a" /* default */].afterEach(function (to) {
    __WEBPACK_IMPORTED_MODULE_4__store_index__["a" /* default */].dispatch('UPDATE_LOADING_STATUS', { isLoading: false });
});

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__service_getData__["a" /* initAppData */])(__WEBPACK_IMPORTED_MODULE_4__store_index__["a" /* default */].state.baseurl).then(function (res) {
    __WEBPACK_IMPORTED_MODULE_4__store_index__["a" /* default */].dispatch('SET_ORGLOGO', res.data.orgLogo);
    __WEBPACK_IMPORTED_MODULE_4__store_index__["a" /* default */].dispatch('SET_ORGNAME', res.data.orgName);
    if (res.data.loginStatus) {
        __WEBPACK_IMPORTED_MODULE_4__store_index__["a" /* default */].dispatch('SET_USER_LOGIN_IN');
        var user = res.data.user;

        if (user.gender == 1) {
            __WEBPACK_IMPORTED_MODULE_4__store_index__["a" /* default */].dispatch('SET_USER_SEX_MAN');
        } else if (user.gender == 2) {
            __WEBPACK_IMPORTED_MODULE_4__store_index__["a" /* default */].dispatch('SET_USER_SEX_WOMEN');
        } else {
            __WEBPACK_IMPORTED_MODULE_4__store_index__["a" /* default */].dispatch('SET_USER_SEX_DEFAULT');
        }

        __WEBPACK_IMPORTED_MODULE_4__store_index__["a" /* default */].dispatch('SET_NICKNAME', user.nickname);

        __WEBPACK_IMPORTED_MODULE_4__store_index__["a" /* default */].dispatch('SET_NAME', user.name);

        __WEBPACK_IMPORTED_MODULE_4__store_index__["a" /* default */].dispatch('SET_MOBILE', user.mobile);

        if (user.avatar) {
            __WEBPACK_IMPORTED_MODULE_4__store_index__["a" /* default */].dispatch('SET_AVATAR', user.avatar);
        }

        if (res.data.isBinding) {
            __WEBPACK_IMPORTED_MODULE_4__store_index__["a" /* default */].dispatch('SET_USER_BINDING_IN');
        } else {
            __WEBPACK_IMPORTED_MODULE_4__store_index__["a" /* default */].dispatch('SET_USER_BINDING_IN');
        }
    } else {
        __WEBPACK_IMPORTED_MODULE_4__store_index__["a" /* default */].dispatch('SET_USER_LOGIN_OUT');
    }
    setDocumentTitle(__WEBPACK_IMPORTED_MODULE_4__store_index__["a" /* default */].state.orgName + '-你看书我买单');
}).catch(function (err) {
    conolr.log(err);
});

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__service_getData__["b" /* getWechatSet */])(locationUrl).then(function (res) {
    var config = res.data;
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].wechat.config({
        debug: false,
        appId: config.appId,
        timestamp: config.timestamp,
        nonceStr: config.nonceStr,
        signature: config.signature,
        jsApiList: ['scanQRCode', 'chooseWXPay', 'onMenuShareTimeline', 'onMenuShareAppMessage'] });
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    router: __WEBPACK_IMPORTED_MODULE_3__router_index__["a" /* default */],
    store: __WEBPACK_IMPORTED_MODULE_4__store_index__["a" /* default */],
    render: function render(h) {
        return h(__WEBPACK_IMPORTED_MODULE_2__App___default.a);
    }
}).$mount('#app-box');

/***/ })
],[191]);


// WEBPACK FOOTER //
// static/js/app.08d0e1168ad48d773a9e.js